import { ReducerCommandType, StringObjectDictionary } from "../Types";
import { localStore } from "../io/localStore";

// ----------------------- Events -----------------------
const CHANGE_PLANTS_RESET = "CHANGE_PLANTS_RESET";
const CHANGE_PLANTDATA = "CHANGE_PLANTDATA";
const CHANGE_SELECTED_PLANTS = "CHANGE_SELECTED_PLANTS";
const CHANGE_PLANTGROUPS = "CHANGE_PLANTGROUPS";

// ----------------------- Types -----------------------
// Reducer
export type PlantReducerType = {
    db: StringObjectDictionary<PlantObjectExtended>,
    selectedPlants: StringObjectDictionary<string>,
    plantGroups: StringObjectDictionary<string>,
}

// Other types
export type PlantObjectExtended = PlantObject & {
    gardenid?: string,
    userid?: string,
    userplant?: boolean,
    partition?: string,
}

export type PlantObject = {
    localization: any
    name_lc: string
    specifictype: string
    alternativename_type: string
    specifictype_lc: string
    namelatin: string
    alternativename_latin: string
    namelatin_lc: string
    nameenglish: string
    nameenglish_lc: string
    full_name_lc: string
    full_search_text_lc: string
    full_name_search_lc: string
    planttypeid: string
    planttype: string
    flowercolor: string[]
    sun_exposure: string[]
    florescence: string[]
    gruppering: string[]
    mature_height: string[]
    seed_pre_sown_month: string[]
    wateramount: string[]
    life_cycle: string[]
    soil: string[]
    properties: string[]
    pruning: string[]
    seed_directly_sown_month: string[]
    diseases_and_pests: string[]
    plant_characteristics: string[]
    toughness_a_to_d: string[]
    nutrition: string[]
    harvesting: string[]
    fertilize_time: string[]
    planting_month: string[]
    color: string[]
    scent: string[]
    rose_type: string[]
    rose_group: string[]
    egenskaper_ros: string[]
    foliagecolor: string[]
    tulip_group: string[]
    tulpan_blomning: string[]
    flower_size: string[]
    dahlia_group: string[]
    narciss_type: string[]
    clematis_group: string[]
    zone: string
    mature_spread: string
    planting_depth: string
    plant_row_distance_cm: string
    plant_distance_cm: string
    plant_sowing_depth_cm: string
    germination_time_days: string
    development_days: string
    public_description: string
    description: string
    snippet_general_desription_text: string
    snippet_general_desription: string
    snippet_grow_and_plant_text: string
    snippet_grow_and_plant: string
    snippet_takle_care_text: string
    snippet_takle_care: string
    snippet_fertilize_text: string
    snippet_fertilize: string
    snippet_crop_text: string
    snippet_crop: string
    snippet_advice_text: string
    snippet_advice: string
    optimal_groning: string
    vase_life: string
    weeks_before: string
    sadd_till_skord: string
    familyname: string
    sys_datecreated_utc_epoch: number
    sys_datemodified_utc_epoch: number
    imageid: string
    publicimageid: string
    hasimage: boolean
    remontancy: boolean
    poisonous: boolean
    cover: boolean
    short_id: string
    namesuggections_lc: string[]
    alternativenames: string
    alternativekeywords: string
    number_of_posts: number
    viewcount_share: number
    number_of_owners: number
    number_of_likes: number
    viewcount_test: number
    viewcount_www: number
    numcoplanting: number
    hascoplanting: boolean
    ljusgroende: boolean
    morker_groende: boolean
    id: string
    type: string
    name: string
    public: boolean
    __sorting__: number
    __score__: number

    grupperingText: string
}

// ----------------------- DefaultState -----------------------
const plantReducerDefaultState: PlantReducerType = {
    db: {},
    selectedPlants: {},
    plantGroups: {}
};

// ----------------------- Reducer -----------------------
const plantReducer = (state = {
    ...plantReducerDefaultState
}, action: ReducerCommandType) => {
    switch (action.type) {
        case CHANGE_PLANTS_RESET: { state = { ...plantReducerDefaultState }; break; }
        case CHANGE_PLANTDATA: { state = { ...state, db: { ...state?.db, ...action.payload } }; break; }
        case CHANGE_SELECTED_PLANTS: { state = { ...state, selectedPlants: action.payload }; break; }
        case CHANGE_PLANTGROUPS: { state = { ...state, plantGroups: action.payload }; break; }

        default: { return state; }
    }
    return state;
};

// ----------------------- Export -----------------------
export {
    plantReducer,
    CHANGE_PLANTS_RESET,
    CHANGE_PLANTDATA,
    CHANGE_SELECTED_PLANTS,
    CHANGE_PLANTGROUPS,
}